import React from "react";
import IntInput from "../intInput/intInput.js";
export default function ConstProvider(props) {
    const { provider } = props;
    return (React.createElement("div", { className: "" },
        React.createElement(IntInput, { defaultValue: provider.value, label: "", onChange: (newValue) => props.onProviderUpdate({ ...provider, value: newValue }) })));
}
